import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { StateHelperService } from '@Core/services/proprietary/state-helper.service';
import { DocumentDetailObjectService } from './document-detail-object.service';
import { DocumentDetailObjectState } from './document-detail-object.state';

@NgModule({
    imports: [NgxsModule.forFeature([DocumentDetailObjectState])],
    declarations: [],
    providers: [DocumentDetailObjectService, StateHelperService],
    exports: []
})
export class DocumentDetailObjectModule { }
